import { useTranslator } from '@/translations/translator';
import { createCache } from 'cross-state';
import { Locale } from 'date-fns';
import enUS from 'date-fns/locale/en-US';

const locales: Record<string, () => Promise<{ default: Locale }>> = {
    en: () => import('date-fns/locale/en-US'),
    de: () => import('date-fns/locale/de'),
    nb: () => import('date-fns/locale/nb'),
    th: () => import('date-fns/locale/th'),
    ro: () => import('date-fns/locale/ro'),
};

const load = createCache(
    async (locale: string) => {
        try {
            const module = await locales[locale]?.();
            return module?.default as Locale;
        } catch (e) {
            console.error('Failed to load locale', e);
            return null;
        }
    },
    { invalidateOnWindowFocus: false },
);

export function useDateFnsLocale(locale?: string) {
    const t = useTranslator();
    const [dfns] = load(locale ?? t.locale).useCache();

    return dfns ?? enUS;
}
